export type FirmwareVersion = {
  major: number;
  minor: number;
  patch: number;
};

export type RetuneExperienceMode = 'legacy-sweep' | 'target-autotune';

export const TARGET_AUTOTUNE_MIN_FIRMWARE: FirmwareVersion = {
  major: 2,
  minor: 2,
  patch: 0,
};

const FIRMWARE_VERSION_REGEX = /(?:^|[^0-9])v?(\d+)\.(\d+)\.(\d+)(?=$|[^0-9])/i;

export function parseFirmwareVersion(value: string | null | undefined): FirmwareVersion | null {
  const match = String(value ?? '').trim().match(FIRMWARE_VERSION_REGEX);
  if (!match) {
    return null;
  }

  const version = {
    major: Number(match[1]),
    minor: Number(match[2]),
    patch: Number(match[3]),
  };

  return Object.values(version).every((part) => Number.isSafeInteger(part) && part >= 0)
    ? version
    : null;
}

export function compareFirmwareVersions(left: FirmwareVersion, right: FirmwareVersion): number {
  if (left.major !== right.major) {
    return left.major - right.major;
  }
  if (left.minor !== right.minor) {
    return left.minor - right.minor;
  }
  return left.patch - right.patch;
}

export function isFirmwareAtLeast(
  value: string | null | undefined,
  minimum: FirmwareVersion
): boolean {
  const parsed = parseFirmwareVersion(value);
  return parsed !== null && compareFirmwareVersions(parsed, minimum) >= 0;
}

export function resolveRetuneExperienceMode(
  firmwareRevision: string | null | undefined
): RetuneExperienceMode {
  return isFirmwareAtLeast(firmwareRevision, TARGET_AUTOTUNE_MIN_FIRMWARE)
    ? 'target-autotune'
    : 'legacy-sweep';
}
